export default __webpack_public_path__ + "static/media/propsicon1.5bee2589.svg";